/*
  This module exports the required CreatePluginFunction for RicosViewer.
  If your plugin uses decorations, then make sure to uncomment 'decorator'.
  (Please find examples of usage in other plugins)
*/

import type { ViewerPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS } from './defaults';
import type { CollapsibleListPluginViewerConfig } from './types';
import { COLLAPSIBLE_LIST_TYPE } from './types';
import { nodeViewRenderers } from './viewer/nodeViewRenderers-loadable';
export { COLLAPSIBLE_LIST_TYPE, CollapsibleListPluginViewerConfig };

export const pluginCollapsibleList: ViewerPluginCreator<
  CollapsibleListPluginViewerConfig
> = config => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: COLLAPSIBLE_LIST_TYPE,
    nodeViewRenderers,
  };
};
